var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "order-new"
  }, [_c('div', {
    staticClass: "subtitle",
    on: {
      "click": _vm.onShowCustomerInfo
    }
  }, [_vm._v("购买人信息")]), _vm._v(" "), _c('ul', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showCustomerInfo),
      expression: "showCustomerInfo"
    }],
    staticClass: "ca-info"
  }, [_c('li', [_vm._v("\n      姓名\n      "), _c('span', {
    staticClass: "inter"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.trim",
      value: (_vm.order.name),
      expression: "order.name",
      modifiers: {
        "trim": true
      }
    }],
    attrs: {
      "type": "text",
      "readonly": ""
    },
    domProps: {
      "value": (_vm.order.name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.order.name = $event.target.value.trim()
      },
      "blur": function($event) {
        _vm.$forceUpdate()
      }
    }
  })])]), _vm._v(" "), _c('li', [_vm._v("\n      手机号码\n      "), _c('span', {
    staticClass: "inter"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.trim",
      value: (_vm.order.mobile),
      expression: "order.mobile",
      modifiers: {
        "trim": true
      }
    }],
    staticStyle: {
      "ime-mode": "disabled"
    },
    attrs: {
      "type": "tel",
      "maxlength": "11",
      "readonly": ""
    },
    domProps: {
      "value": (_vm.order.mobile)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.order.mobile = $event.target.value.trim()
      },
      "blur": function($event) {
        _vm.$forceUpdate()
      }
    }
  })])]), _vm._v(" "), _c('li', [_vm._v("\n      回执编号\n      "), _c('span', {
    staticClass: "red"
  }), _vm._v(" "), _c('span', {
    staticClass: "inter"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.survey_code),
      expression: "survey_code"
    }],
    attrs: {
      "type": "text",
      "maxlength": "15",
      "readonly": ""
    },
    domProps: {
      "value": (_vm.survey_code)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.survey_code = $event.target.value
      }
    }
  })])])]), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('ul', {
    staticClass: "ca-info"
  }, [_c('li', {
    on: {
      "click": _vm.onPickerClick
    }
  }, [_vm._v("\n      套餐名称\n      "), _c('span', {
    staticClass: "red"
  }, [_vm._v("*")]), _vm._v(" "), _c('span', {
    staticClass: "select"
  }, [_vm._v(">")]), _vm._v(" "), _c('span', {
    staticClass: "selected"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.selectedPkgTitle),
      expression: "selectedPkgTitle"
    }],
    staticStyle: {
      "width": "130px"
    },
    attrs: {
      "type": "text",
      "readonly": ""
    },
    domProps: {
      "value": (_vm.selectedPkgTitle)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.selectedPkgTitle = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('li', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.is_trade_no),
      expression: "is_trade_no"
    }],
    staticStyle: {
      "line-height": "50px",
      "padding": "0"
    }
  }, [_vm._v("\n      外部商城订单编号\n      "), _c('span', {
    staticClass: "red"
  }, [_vm._v("*")]), _vm._v(" "), _c('span', {
    staticClass: "inter"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.trim",
      value: (_vm.trade_no),
      expression: "trade_no",
      modifiers: {
        "trim": true
      }
    }],
    staticStyle: {
      "height": "22px",
      "width": "160px"
    },
    attrs: {
      "type": "tel"
    },
    domProps: {
      "value": (_vm.trade_no)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.trade_no = $event.target.value.trim()
      },
      "blur": function($event) {
        _vm.$forceUpdate()
      }
    }
  })])]), _vm._v(" "), _c('li', {
    on: {
      "click": _vm.onPriceClick
    }
  }, [_vm._v("\n      套餐价格\n      "), _c('span', {
    staticClass: "red"
  }, [_vm._v("*")]), _vm._v(" "), _c('span', {
    staticClass: "select"
  }, [_vm._v(">")]), _vm._v(" "), _c('span', {
    staticClass: "selected"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.selectedPrice),
      expression: "selectedPrice"
    }],
    staticStyle: {
      "width": "100px"
    },
    attrs: {
      "type": "text",
      "readonly": ""
    },
    domProps: {
      "value": (_vm.selectedPrice)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.selectedPrice = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('li', {
    on: {
      "click": _vm.onPeriodClick
    }
  }, [_vm._v("\n      服务时长\n      "), _c('span', {
    staticClass: "red"
  }, [_vm._v("*")]), _vm._v(" "), _c('span', {
    staticClass: "select"
  }, [_vm._v(">")]), _vm._v(" "), _c('span', {
    staticClass: "selected"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.selectedPeriod),
      expression: "selectedPeriod"
    }],
    staticStyle: {
      "width": "100px"
    },
    attrs: {
      "type": "text",
      "readonly": ""
    },
    domProps: {
      "value": (_vm.selectedPeriod)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.selectedPeriod = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('li', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.is_dikou),
      expression: "is_dikou"
    }]
  }, [_vm._v("\n      可用于抵扣的金额\n      "), _c('span', {
    staticClass: "selected"
  }, [_vm._v(_vm._s(_vm.order.dikou_valid_amount || '0') + "元")])]), _vm._v(" "), _c('li', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.is_dikou),
      expression: "is_dikou"
    }]
  }, [_vm._v("\n      本订单抵扣金额\n      "), _c('span', {
    staticClass: "selected"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.number",
      value: (_vm.order.dikou_amount),
      expression: "order.dikou_amount",
      modifiers: {
        "number": true
      }
    }],
    ref: "txtDikouAmount",
    staticStyle: {
      "width": "150px"
    },
    attrs: {
      "readonly": "",
      "type": "tel",
      "placeholder": "请输入本订单抵扣金额"
    },
    domProps: {
      "value": (_vm.order.dikou_amount)
    },
    on: {
      "focus": _vm.onDikouAmountFocus,
      "change": _vm.onDikouAmountChange,
      "blur": [_vm.onDikouAmountChange, function($event) {
        _vm.$forceUpdate()
      }],
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.order.dikou_amount = _vm._n($event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('li', [_vm._v("\n      本订单应付金额\n      "), _c('span', {
    staticClass: "selected"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.payPrice),
      expression: "payPrice"
    }],
    staticStyle: {
      "width": "150px"
    },
    attrs: {
      "type": "tel",
      "readonly": ""
    },
    domProps: {
      "value": (_vm.payPrice)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.payPrice = $event.target.value
      }
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "actions mt-50"
  }, [_c('mt-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.onSubmitClick
    }
  }, [_vm._v("提交")]), _vm._v(" "), _c('p', {
    staticClass: "mt-50",
    staticStyle: {
      "font-size": "13px",
      "padding": "5px 20px"
    }
  }, [_vm._v("温馨提示：订单创建过程中遇到问题，可在企业号【我的客户】栏目中直接发送问题消息到后台，值班技术支持会尽快给您回复。")])], 1), _vm._v(" "), _c('pd-select-box', {
    ref: "pdSelect",
    attrs: {
      "customMobile": _vm.order.mobile
    },
    on: {
      "change": _vm.onPkgChange
    }
  }), _vm._v(" "), _c('price-select-box', {
    ref: "priceSelect",
    on: {
      "change": _vm.onPriceChange
    }
  }), _vm._v(" "), _c('period-select-box', {
    ref: "periodSelect",
    on: {
      "change": _vm.onPeriodChange
    }
  })], 1)
}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "subtitle"
  }, [_vm._v("\n    套餐信息\n    "), _c('span', [_vm._v("（*项为必填项）")])])
}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./~/_vue-loader@13.0.2@vue-loader/lib/template-compiler?{"id":"data-v-12fa99f4","hasScoped":true}!./~/_vue-loader@13.0.2@vue-loader/lib/selector.js?type=template&index=0!./src/views/order/OrderNewPkg.vue
// module id = 230
// module chunks = 0